const memoryStore = {
  localStorage: new Map(),
  sessionStorage: new Map(),
};

function getNativeStorage(type) {
  if (typeof window === 'undefined') return null;
  try {
    const storage = window[type];
    const key = '__iv1_storage_test__';
    storage.setItem(key, '1');
    storage.removeItem(key);
    return storage;
  } catch {
    return null;
  }
}

function getMemory(type) {
  return memoryStore[type];
}

function createSafeStorage(type) {
  return {
    getItem(key) {
      try {
        const storage = getNativeStorage(type);
        if (storage) return storage.getItem(key);
        return getMemory(type).get(key) ?? null;
      } catch {
        return null;
      }
    },
    setItem(key, value) {
      try {
        const storage = getNativeStorage(type);
        if (storage) storage.setItem(key, String(value));
        else getMemory(type).set(key, String(value));
      } catch {}
    },
    removeItem(key) {
      try {
        const storage = getNativeStorage(type);
        if (storage) storage.removeItem(key);
        getMemory(type).delete(key);
      } catch {}
    },
  };
}

export const safeLocalStorage = createSafeStorage('localStorage');
export const safeSessionStorage = createSafeStorage('sessionStorage');
